import { Grid } from "@mui/material";
import React, { useContext, useState } from "react";
import { Button } from "../../../../controls";
import { useTranslation } from "react-i18next";
import { action, controller, Server } from "../../../../api/Server";
import { PrintDiv, ToFormData } from "../../../../hooks/Method";
import { toast } from "react-toastify";
import { AppContext } from "../../../../App";
import GeneralPrinterReceipt from "./printReceipt/GeneralPrinterReceipt";
import ThermalPrinterRecept from "./printReceipt/ThermalPrinterRecept";

const QuoteSale = ({ values, emailInv, handleClearCart }) => {
  const { selStore, setLoader, settings } = useContext(AppContext);
  const { t } = useTranslation();
  const [receiptData, setReceiptData] = useState({});
  const [loading, setLoading] = useState(false);

  const handleEmailReceipt = (id) => {
    Server(controller.QuoteSale + action.EmailReceipt).getById(id, (res) => {
      console.log("status: ", res.msg);
    });
  };

  const handleQuoteSale = () => {
    setLoader(true);
    setLoading(true);
    const onComplete = (res) => {
      if (res && res.status === 200) {
        setReceiptData(res.result);
        setTimeout(() => {
          PrintDiv("printQuoteReceipt");
          handleClearCart && handleClearCart();
          setLoader(false);
          setLoading(false);
          // Email Sale Invoice
          if ((settings.emailInvoice === 2 || emailInv) && values.cstmrId) {
            handleEmailReceipt(res.result.id);
          }
        }, 1000);
      } else if (res?.msg) {
        toast.error(res.msg);
        setLoader(false);
      } else {
        console.error("Error: ", res);
        setLoader(false);
      }
    };

    Server(controller.QuoteSale + action.Post).post(
      ToFormData({
        ...values,
        quoteItems: values.sellItems.map((j) =>
          j.itemType === 2 ? { ...j, productId: "" } : j
        ),
        quoteDate: new Date().toISOString(),
        toPay: values.totalPay,
        customerId: values.cstmrId,

        storeId: selStore,
      }),
      onComplete
    );
  };

  return (
    <>
      {values.cstmrId && (
        <Grid item xs={12} md={6}>
          <Button
            onClick={handleQuoteSale}
            fullWidth
            loading={loading}
            variant="text"
          >
            {t("quoteSale")}
          </Button>
        </Grid>
      )}

      <div className="d-none" id="printQuoteReceipt">
        {settings && settings.store && settings.store.receiptType === 2 ? (
          <GeneralPrinterReceipt data={receiptData} />
        ) : (
          <ThermalPrinterRecept data={receiptData} />
        )}
      </div>
    </>
  );
};

export default QuoteSale;
